import {contentCardSchema} from '../../../../../schemas/contentCardSchema';
import {z} from 'zod';
import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {ContentSelectionStrategyValue} from 'common/src/modules/contentFeeds/contentFeeds.enums';
import {ContentFeedNode} from 'common/src/modules/decisionTree/decisionTree.types';

export function convertContentAPICardToAICard(
  contentCard: ContentFeedNode,
): z.output<typeof contentCardSchema> {
  const candidate: z.input<typeof contentCardSchema> = {
    name: contentCard.name ?? '',
    cardId: contentCard.id,
    description: contentCard.description ?? '',
    strategy: contentCard.strategy ?? ContentSelectionStrategyValue.Matching,
    type: NodeType.CONTENT_FEED,
    ...(contentCard.configuration?.conditions
      ? {
          conditions:
            contentCard.configuration?.conditions.map((condition) => ({
              feedColumnSignalKey: condition.feedColumnSignalKey ?? '',
              operator: condition.operator ?? 0,
              signalKey: condition.signalKey ?? '',
              feedColumnUIName: condition.feedColumnUIName ?? '',
              signalMainCategory: condition.signalMainCategory,
              signalUIName: condition.signalUIName ?? '',
            })) ?? [],
        }
      : {conditions: null}),
    contentId: contentCard.contentId ?? null,
    contentFeedId: contentCard.contentFeedId,
    contentSetId: contentCard.contentSetId ?? null,
  } satisfies z.output<typeof contentCardSchema>;

  return candidate;
}
